import { render, staticRenderFns } from "./DemoTile.vue?vue&type=template&id=1e2ffbb6&scoped=true"
import script from "./DemoTile.vue?vue&type=script&lang=js"
export * from "./DemoTile.vue?vue&type=script&lang=js"
import style0 from "./DemoTile.vue?vue&type=style&index=0&id=1e2ffbb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ffbb6",
  null
  
)

export default component.exports